import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { BlobResource } from './BlobResource.mjs';
import { INTERNAL_FORMAT_TO_BYTES_PER_PIXEL } from '../const.mjs';
var CompressedTextureResource = /*#__PURE__*/function (_BlobResource) {
  _inherits(CompressedTextureResource, _BlobResource);
  var _super = _createSuper(CompressedTextureResource);
  function CompressedTextureResource(source, options) {
    var _this;
    _classCallCheck(this, CompressedTextureResource);
    _this = _super.call(this, source, options);
    _this.format = options.format;
    _this.levels = options.levels || 1;
    _this._width = options.width;
    _this._height = options.height;
    _this._extension = CompressedTextureResource._formatToExtension(_this.format);
    if (options.levelBuffers || _this.buffer) {
      _this._levelBuffers = options.levelBuffers || CompressedTextureResource._createLevelBuffers(source instanceof Uint8Array ? source : _this.buffer.uint8View, _this.format, _this.levels, 4, 4, _this.width, _this.height);
    }
    return _this;
  }
  _createClass(CompressedTextureResource, [{
    key: "upload",
    value: function upload(renderer, _texture, _glTexture) {
      var gl = renderer.gl;
      var extension = renderer.context.extensions[this._extension];
      if (!extension) {
        throw new Error("".concat(this._extension, " textures are not supported on the current machine"));
      }
      if (!this._levelBuffers) {
        return false;
      }
      for (var i = 0, j = this.levels; i < j; i++) {
        var _this$_levelBuffers$i = this._levelBuffers[i],
          levelID = _this$_levelBuffers$i.levelID,
          levelWidth = _this$_levelBuffers$i.levelWidth,
          levelHeight = _this$_levelBuffers$i.levelHeight,
          levelBuffer = _this$_levelBuffers$i.levelBuffer;
        gl.compressedTexImage2D(gl.TEXTURE_2D, levelID, this.format, levelWidth, levelHeight, 0, levelBuffer);
      }
      return true;
    }
  }, {
    key: "onBlobLoaded",
    value: function onBlobLoaded() {
      this._levelBuffers = CompressedTextureResource._createLevelBuffers(this.buffer.uint8View, this.format, this.levels, 4, 4, this.width, this.height);
    }
  }], [{
    key: "_formatToExtension",
    value: function _formatToExtension(format) {
      if (format >= 33776 && format <= 33779) {
        return "s3tc";
      } else if (format >= 37488 && format <= 37497) {
        return "etc";
      } else if (format >= 35840 && format <= 35843) {
        return "pvrtc";
      } else if (format >= 36196) {
        return "etc1";
      } else if (format >= 35986 && format <= 34798) {
        return "atc";
      }
      throw new Error("Invalid (compressed) texture format given!");
    }
  }, {
    key: "_createLevelBuffers",
    value: function _createLevelBuffers(buffer, format, levels, blockWidth, blockHeight, imageWidth, imageHeight) {
      var buffers = new Array(levels);
      var offset = buffer.byteOffset;
      var levelWidth = imageWidth;
      var levelHeight = imageHeight;
      var alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1);
      var alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1);
      var levelSize = alignedLevelWidth * alignedLevelHeight * INTERNAL_FORMAT_TO_BYTES_PER_PIXEL[format];
      for (var i = 0; i < levels; i++) {
        buffers[i] = {
          levelID: i,
          levelWidth: levels > 1 ? levelWidth : alignedLevelWidth,
          levelHeight: levels > 1 ? levelHeight : alignedLevelHeight,
          levelBuffer: new Uint8Array(buffer.buffer, offset, levelSize)
        };
        offset += levelSize;
        levelWidth = levelWidth >> 1 || 1;
        levelHeight = levelHeight >> 1 || 1;
        alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1);
        alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1);
        levelSize = alignedLevelWidth * alignedLevelHeight * INTERNAL_FORMAT_TO_BYTES_PER_PIXEL[format];
      }
      return buffers;
    }
  }]);
  return CompressedTextureResource;
}(BlobResource);
export { CompressedTextureResource };